import type { Example } from '../types';

export const pbrMaterialsExample: Example = {
  id: 'pbr-materials',
  title: 'PBR Materials',
  categoryId: 'viewer',
  description: 'Physically-based rendering: metalness, roughness, clearcoat',
  scadCode: `/* PBR Materials */

// markdown:tip
// **PBR Materials** — Use \`material_def()\` to apply physically-based
// rendering properties to your objects. Try adjusting the sliders below
// and watch the spheres respond to lighting in real time.

/* [Tune Materials] */

// Global roughness scale (multiplies each sphere's base roughness)
roughness_scale = 1.0; // [0.1:0.05:2.0]

// Global metalness scale
metalness_scale = 1.0; // [0.1:0.05:2.0]

// Light intensity
light_intensity = 0.8; // [0.1:0.05:2.0]

// --- parameters end ---

spacing = 26;
r = 10;

module pbr_sphere(x, col, metal, rough, cc=0, label="") {
  m = material_def(
    metalness  = min(1, metal  * metalness_scale),
    roughness  = min(1, rough  * roughness_scale),
    clearcoat  = cc
  );
  color(col) material(m) translate([x, 0, 0]) sphere(r=r, $fn=64);
}

// Matte plastic
pbr_sphere(-spacing*2, [0.85, 0.2, 0.2],  metal=0.0, rough=0.9);

// Glossy plastic
pbr_sphere(-spacing,   [0.2, 0.55, 0.9],  metal=0.0, rough=0.15);

// Brushed metal
pbr_sphere(0,          [0.7, 0.7, 0.72],  metal=0.9, rough=0.45);

// Mirror chrome
pbr_sphere(spacing,    [0.95, 0.95, 0.98], metal=1.0, rough=0.02);

// Clearcoat finish (gloss coat over coloured base)
pbr_sphere(spacing*2,  [0.15, 0.65, 0.35], metal=0.1, rough=0.5, cc=1.0);

// Ground plate
color([0.15, 0.15, 0.15])
material(material_def(roughness=0.8, metalness=0.0))
translate([0, 0, -r - 1])
  cube([spacing*4 + r*2 + 8, r*2 + 8, 2], center=true);

// Three-point lighting
light_directional(
  color=[1.0, 0.97, 0.9],
  position=[120, -80, 160],
  intensity=light_intensity
);
light_directional(
  color=[0.4, 0.55, 0.9],
  position=[-100, 60, 80],
  intensity=light_intensity * 0.5
);
light_directional(
  color=[0.9, 0.85, 0.7],
  position=[0, 120, 40],
  intensity=light_intensity * 0.3
);
`,
};
